module.exports = __webpack_public_path__ + "img/medal.fa24dfc3.png";